import EmptyStatePattern from './EmptyStatePattern';
import DefaultEmptyState from './DefaultEmptyState';

export default DefaultEmptyState;
export { EmptyStatePattern };
